import { Link } from '@billy/design-system'
import { FC, PropsWithChildren } from 'react'
import { Trans, useTranslation } from 'react-i18next'

interface LearnMoreLinkProps {
  link: string
}

const LearnMoreLink: FC<PropsWithChildren<LearnMoreLinkProps>> = ({ link, children }) => {
  return (
    <Link href={link} target="_blank" rel="noopener" underlined>
      {children}
    </Link>
  )
}

export interface LearnMoreTranslationProps {
  i18nKey: string
  linkKey: string
}

export const LearnMoreTranslation: FC<LearnMoreTranslationProps> = ({ i18nKey, linkKey }) => {
  const { t } = useTranslation()

  return (
    <Trans
      i18nKey={i18nKey}
      components={{
        Link: <LearnMoreLink link={t(linkKey)} />,
      }}
    />
  )
}
